import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

import Home from "@/pages/Home";
import Business from "@/pages/Business";
import Individual from "@/pages/Individual";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Calculators from "@/pages/Calculators";
import MFPMSAIF from "@/pages/products/MFPMSAIF";
import DirectEquity from "@/pages/products/DirectEquity";
import FixedIncomeInsurance from "@/pages/products/FixedIncomeInsurance";
import DAAE from "@/pages/products/DAAE";
import StartInvesting from "@/pages/resources/StartInvesting";
import SIP from "@/pages/resources/SIP";
import Retirement from "@/pages/resources/Retirement";
import Goals from "@/pages/Goals";
import GoalPage from "@/pages/GoalPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Privacy from "@/pages/Privacy";
import NotFound from "@/pages/NotFound";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function SmoothScroll() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
}

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <SmoothScroll />
        <ScrollManager />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/business" element={<Business />} />
            <Route path="/individual" element={<Individual />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/calculators" element={<Calculators />} />
            <Route path="/products/mf-pms-aif" element={<MFPMSAIF />} />
            <Route path="/products/direct-equity" element={<DirectEquity />} />
            <Route path="/products/fixed-income-insurance" element={<FixedIncomeInsurance />} />
            <Route path="/products/daae" element={<DAAE />} />
            <Route path="/start-investing" element={<StartInvesting />} />
            <Route path="/sip-investment" element={<SIP />} />
            <Route path="/retirement-planning" element={<Retirement />} />
            <Route path="/goals" element={<Goals />} />
            <Route path="/goals/:slug" element={<GoalPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
